import { useLang } from "../../i18n";

export function Marquee() {
  const { t } = useLang();
  const words = t.marquee;
  const sequence = [...words, ...words];

  return (
    <section aria-hidden className="py-14 md:py-20 border-y border-[var(--ink)]/10 overflow-hidden marquee-mask select-none">
      <div className="marquee-track">
        {sequence.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display italic font-light text-5xl md:text-7xl px-8 text-[var(--ink)]">
              {w}
            </span>
            <span className="text-[var(--gold)] text-3xl">&#9679;</span>
          </span>
        ))}
      </div>
    </section>
  );
}
